<div class="container-fluid px-0">
  <div class="d-lg-flex flex-row align-content-center pb-3">
    <div class="d-lg-flex flex-row gap-4 align-items-center col-6">
      <!-- <div class="col-md-12 col-lg-6 col-xl-4 col-xxl-2" id="inputSearchWrap">
                <div class="form-control d-flex justify-content-between align-items-center text-muted">
                    <input type="text" id="searchInput" class="border-0" placeholder="Search by anything" />
                    <div class="icon"><i class="bi bi-search"></i></div>
                </div>
            </div> -->
      <div class="d-flex gap-2 align-items-center">
        <div class="text-muted col-auto">Filter by</div>
        <ng-select [multiple]="true" [items]="statuses" groupBy="selectedAllGroup" [selectableGroup]="true"
          bindLabel="name" bindValue="value" placeholder="Status" [compareWith]="compareAccounts"
          [(ngModel)]="selectedStatus" [closeOnSelect]="false" (change)="onSelectionChange()" style="max-width: 520px;">
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" /> Select All
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of items | slice:0:2">
              <span class="ng-value-label">{{statusLabelName(item)}}</span>
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>

            </div>
            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">{{items.length - 2}} more...</span>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="d-lg-flex flex-row gap-4 align-items-center col-6 justify-content-end">
      <!-- entire save view div -->
      <app-saved-search #savedSearch [gridApi]="gridApi" [viewFilterType]="viewFilterType" [module]="module"
        (onClearFilters)="clearFiltersExternally()"></app-saved-search>
    </div>
  </div>

  <div class="row" *ngIf="this.customerId != null">

    <!-- <ag-grid-angular style="min-height: 400px; height: 800px;" class="ag-theme-alpine w-100"
            [suppressRowClickSelection]="true" [columnDefs]="columnDefs" [sideBar]="sideBar"
            [defaultColDef]="defaultColDef" [pagination]="true" [paginationPageSize]="paginationPageSize"
            [cacheBlockSize]="cacheBlockSize" [rowSelection]="'multiple'" [animateRows]="true" [rowData]="rowData"
            (gridReady)="onGridReady($event)"></ag-grid-angular> -->

    <ag-grid-angular style="min-height: 400px; height: 800px;" class="ag-theme-alpine w-100"
      [suppressRowClickSelection]="true" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [sideBar]="sideBar"
      [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector"
      [pagination]="true" [cacheBlockSize]="cacheBlockSize" [rowSelection]="'multiple'" [animateRows]="true"
      [rowData]="rowData" (dragStopped)="eventHandlingListener($event)" (filterChanged)="eventHandlingListener($event)"
      (columnVisible)="onColumnVisible($event)" (sortChanged)="eventHandlingListener($event)"
      (gridReady)="onGridReady($event)"></ag-grid-angular>


  </div>
</div>
